export default {
  '000': `var(--ehi-space-0)`,
  '025': `var(--ehi-space-025)`,
  '050': `var(--ehi-space-050)`,
  '075': `var(--ehi-space-075)`,
  100: `var(--ehi-space-100)`,
  150: `var(--ehi-space-150)`,
  200: `var(--ehi-space-200)`,
  250: `var(--ehi-space-250)`,
  300: `var(--ehi-space-300)`,
  400: `var(--ehi-space-400)`,
  500: `var(--ehi-space-500)`,
  600: `var(--ehi-space-600)`,
  800: `var(--ehi-space-800)`,
  900: `var(--ehi-space-900)`,
  1000: `var(--ehi-space-1000)`,
};
